import ConsentForm from "./consent-form";
import { Drawer, SimpleToolbar, Toast } from "../../components";
import { AuthContext } from "../../context";
import { useDrawer } from "../../hooks";
import { useState, useContext, useEffect } from "react";
import { Loader } from "../../components";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { laboratoryServices } from "../../services";
import { Container, Grid, makeStyles, Typography } from "@material-ui/core";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

export default function EditConsent() {
  const { authState } = useContext(AuthContext);
  const { isOpen, setIsOpen } = useDrawer();
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [informedConsent, setInformedConsent] = useState(null);
  const classes = useStyles();
  const history = useHistory();
  const { informedConsentId } = useParams();
  const handleUpdateConsent = async (data) => {
    const formData = new FormData();
    formData.append("name", data.name);
    formData.append("informedConsentId", informedConsentId);
    if (data.file && data.file.length > 0) {
      formData.append("file", data.file[0]);
    }

    try {
      setLoading(true);
      const { status, response } = await laboratoryServices.patchInformedConsents(
        {
          info: formData,
          token: authState.token,
        }
      );
      setToast(true);
      setToastMessage(
        status === 200 ? "Documento editado exitosamente" : response.message
      );
      if (status === 200) {
        setTimeout(() => {
          history.replace("/consent");
        }, 700);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const getInformedConsent = async () => {
      try {
        setLoading(true);
        const { status, response } =
          await laboratoryServices.getInformedConsents({
            token: authState.token,
          });
        if (status === 200) {
          const found = response.find((doc) => doc._id === informedConsentId);
          if (found) {
            setInformedConsent(found);
            setLoading(false);
          } else history.replace("/consent");
        } else {
          setToast(true);
          setToastMessage("Error de carga.");
        }
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    getInformedConsent();
  }, []);

  return (
    <>
      {" "}
      <Drawer open={isOpen} setOpen={(value) => setIsOpen(value)} />
      <Grid container className={classes.root}>
        {loading && <Loader loading={true} />}
        <Toast
          open={toast}
          message={toastMessage}
          close={() => setToast(false)}
        />
        <Grid item xs={12} className={classes.content}>
          <Container maxWidth={false}>
            <SimpleToolbar
              hideExport={true}
              isOpen={isOpen}
              setIsOpen={(value) => setIsOpen(value)}
              noSearchBar
            />
          </Container>
          <Container maxWidth="md" component={"main"}>
            <Typography
              variant="h6"
              gutterBottom
              color="textPrimary"
              align="center"
            >
              Editar consentimiento
            </Typography>
            <ConsentForm
              onSubmit={handleUpdateConsent}
              isEdit={true}
              loading={loading}
              defaultValues={informedConsent}
            />
            ;
          </Container>
        </Grid>
      </Grid>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: 24,
    paddingBottom: 24,
    flex: 1,
    minHeight: "100vh",
  },
}));
